import { Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import { TabsProps } from './types';

import * as S from './styled';

export const Tabs = ({ tabs, currentTab, onChange }: TabsProps) => {
    const { t } = useTranslation();

    return (
        <S.TabsWrapper>
            {tabs.map((tab) => {
                const isActive = currentTab === tab.id;

                return (
                    <S.TabButton
                        $isActive={isActive}
                        onClick={() => onChange(tab.id)}
                        key={tab.id}
                        data-locator={tab.dataLocator}
                    >
                        <Text type="overline" color={isActive ? 'text-main' : 'text-secondary-subdued'}>
                            {t(tab.title)}
                        </Text>
                    </S.TabButton>
                );
            })}
        </S.TabsWrapper>
    );
};
